import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Helmet, HelmetProvider } from "react-helmet-async";

import './App.css';
import Home from './pages/Home/Home';
import NotFound from './pages/NotFound/NotFound';
import { useStateContext } from './context/ContextProvider';

// PROJECTS 
import AziziVeniceNina from './pages/Projects/Azizi/Venice/AziziVeniceNina';
import LanguageWrapper from './components/Language/LanguageWrapper';
import Thankyou from './pages/Thankyou/Thankyou';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TestPage from './pages/Projects/TestDev/TestPro/TestPage';
import AziziVeniceSnapchatNina from './pages/Projects/Azizi/Venice/AziziVeniceSnapchatNina';
import AziziRivieraRetailNina from './pages/Projects/Azizi/Riviera-Retail/AziziRivieraRetailNina';
import AziziRivieraRetailSnapchatNina from './pages/Projects/Azizi/Riviera-Retail/AziziRivieraRetailSnapchatNina';
import DamacRiversideNina from './pages/Projects/Damac/Riverside/DamacRiversideNina';
import DamacRiversideSnapchatNina from './pages/Projects/Damac/Riverside/DamacRiversideSnapchatNina';
import Blocked from './pages/NotFound/Blocked';
import AziziMilanNina from './pages/Projects/Azizi/Milan/AziziMilanNina';
import AziziMilanSnapchatNina from './pages/Projects/Azizi/Milan/AziziMilanSnapchatNina';
import AziziMilanApoelezz from './pages/Apoelezz/Azizi/Milan/AziziMilanApoelezz';
import BinghattiAquariseApoelezz from './pages/Apoelezz/Binghatti/Aquarise/BinghattiAquariseApoelezz';
import TigerAnandaApoelezz from './pages/Apoelezz/Tiger/Ananda/TigerAnandaApoelezz';
import AziziVeniceHikal from './pages/Hikal/Azizi/Venice/AziziVeniceHikal';
import AziziVeniceAsm from './pages/Asm/Azizi/Venice/AziziVeniceAsm';
import AziziMilanAsm from './pages/Asm/Azizi/Milan/AziziMilanAsm';
import AziziMilanHikal from './pages/Hikal/Azizi/Milan/AziziMilanHikal';
import BinghattiCircleHikal from './pages/Hikal/Binghatti/Circle/BinghattiCircleHikal';
import BinghattiHillviewsApoelezz from './pages/Apoelezz/Binghatti/Hillviews/BinghattiHillviewsApoelezz';
import AziziRivieraAsm from './pages/Asm/Azizi/Riviera/AziziRivieraAsm';
import BinghattiAlJaddafHikal from './pages/Hikal/Binghatti/AlJaddaf/BinghattiAlJaddafHikal';
import BinghattiSkybladeHikal from './pages/Hikal/Binghatti/Skyblade/BinghattiSkybladeHikal';
import DamacTownhouseHikal from './pages/Hikal/Damac/Townhouse/DamacTownhouseHikal';
import HikalAziziMilan from './pages/Hikal/Azizi/Milan/HikalAziziMilan';
import NinaAziziMilan from './pages/Nina/Azizi/Milan/NinaAziziMilan';
import AsmAziziMilan from './pages/Asm/Azizi/Milan/AsmAziziMilan';
import NinaAziziVenice from './pages/Nina/Azizi/Venice/NinaAziziVenice';
import NinaAziziRiviera from './pages/Nina/Azizi/Riviera/NinaAziziRiviera';
import HikalOneLaguna from './pages/Hikal/One/Laguna/HikalOneLaguna';
import NinaOneLaguna from './pages/Nina/One/Laguna/NinaOneLaguna';
import TaviraAziziVenice from './pages/Tavira/Azizi/Venice/TaviraAziziVenice';
import RichMindOystra from './pages/Richmind/Oystra/RichMindOystra';
import NinaAziziLeily from './pages/Nina/Azizi/Leily/NinaAziziLeily';
import NinaLibyaEvent from './pages/Nina/Event/Libya/NinaLibyaEvent';
import EventThankYou from './pages/Thankyou/EventThankyou';
import NinaBinghattiMercedes from './pages/Nina/Binghatti/Mercedes/NinaBinghattiMercedes';
import SipAiTest from './pages/Projects/TestDev/TestPro/SipAiTest';
import NinaBinghattiVintage from './pages/Nina/Binghatti/Vintage/NinaBinghattiVintage';
import FePeacehomesSkyline from './pages/Nina/PeaceHomes/Skyline/FePeacehomesSkyline';
import AziziVeniceRetail from './pages/HikalRE/Azizi/Venice/AziziVeniceRetail';
import AziziVeniceApartment from './pages/HikalRE/Azizi/Venice/AziziVeniceApartment';
import AziziFlorence from './pages/HikalRE/Azizi/Florence/AziziFlorence';
import BinghattiSpectre from './pages/HikalRE/Binghatti/Spectre/BinghattiSpectre';


// HELMET MANAGER
const HelmetManager = ({ routes }) => {
  const location = useLocation();

  // Normalize pathname for matching (remove trailing slashes)
  const normalizedPath = location.pathname.replace(/\/+$/, '');

  // const currentRoute = routes.find(route => route.path === location.pathname);
  // Find the matching route
  const currentRoute = routes.find(route => {
    const routePath = route.path.replace(/\/+$/, '');
    if (routePath === "/*") {
      return true; // Wildcard will match if no other route matches
    }
    return normalizedPath === routePath || (normalizedPath + '/') === routePath;
  });

  return (
    currentRoute && (
      <Helmet>
        <title>{currentRoute.title}</title>
        <meta name="description" content={currentRoute.description} />
        {/* PIXEL */}
        {/* Google Tag Manager - HIKAL - 250110 */}
        <script>
          {/* {`
          (function (w, d, s, l, i) {
              w[l] = w[l] || [];
            w[l].push({"gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", "GTM-WM52CQMZ");
          `} */}
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-T37TXKS4');
          `}
        </script>
        {/* End Google Tag Manager */}
        {/* SNAPCHAT */}
        <script type='text/javascript'>
          {`(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
          {a.handleRequest ? a.handleRequest.apply(a, arguments) : a.queue.push(arguments)};
          a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
          r.src=n;var u=t.getElementsByTagName(s)[0];
u.parentNode.insertBefore(r,u);})(window,document,
          'https://sc-static.net/scevent.min.js');
          snaptr('init', 'c5f122f8-a74e-4ec4-912d-3c38095419c9', { });
          snaptr('track', 'PAGE_VIEW');
          `}
        </script>
      </Helmet>
    )
  );
};

const App = () => {
  const {
    setAllRoutes,
    i18n
  } = useStateContext();

  const location = useLocation();

  const [source, setSource] = useState("Website");

  useEffect(() => {
    setAllRoutes(routes);
  }, []);

  useEffect(() => {
    setAllRoutes(routes);
    i18n.changeLanguage(localStorage.getItem("language"));
    document.body.style.direction = localStorage.getItem("direction");
    document.body.style.fontFamily = localStorage.getItem("font");
    // document.documentElement.style.setProperty("font-family", localStorage.getItem("font"));
  }, []);

  // Dynamically update body background class
  useEffect(() => {
    // Normalize pathname for matching (remove trailing slashes)
    const normalizedPath = location.pathname.replace(/\/+$/, '');

    // Find the matching route
    const currentRoute = routes.find(route => {
      const routePath = route.path.replace(/\/+$/, '');
      if (routePath === "/*") {
        return true; // Wildcard will match if no other route matches
      }
      return normalizedPath === routePath || (normalizedPath + '/') === routePath;
    });

    // Debugging logs
    console.log("Current Pathname:", location.pathname);
    console.log("Normalized Path:", normalizedPath);
    console.log("Current Route:", currentRoute);

    // List of all possible background classes
    const backgroundClasses = ["black-bg", "light-bg", "gradient-bg", "white-bg"];

    // Remove all background classes from body
    backgroundClasses.forEach(className => {
      document.body.classList.remove(className);
    });

    // Apply the new background class if specified
    if (currentRoute && currentRoute.bodyBackgroundClass) {
      console.log("Applying background class:", currentRoute.bodyBackgroundClass);
      document.body.classList.add(currentRoute.bodyBackgroundClass);
    } else {
      console.log("No background class specified for this route");
    }
  }, [location]);

  // SOURCE
  useEffect(() => {
    // GET CURRENT URL
    const urlParams = new URLSearchParams(window.location.search.toLowerCase());
    const fullUrl = window.location.href.toLowerCase();
    setSource(localStorage.getItem("leadSource") || "Website"); // Check stored source first
    let clickId = null;

    // Check if stored data is stale (e.g., older than 24 hours)
    const lastStored = localStorage.getItem("leadSourceTimestamp");
    if (lastStored && Date.now() - parseInt(lastStored) > 24 * 60 * 1000) {
      localStorage.removeItem("leadSource");
      localStorage.removeItem("originalReferrer");
      localStorage.removeItem("leadSourceTimestamp");
      setSource(null);
    }

    // Store original referrer on first load
    if (!localStorage.getItem("originalReferrer")) {
      localStorage.setItem("originalReferrer", document.referrer || "");
    }

    // 1. Check click IDs (highest priority)
    if (urlParams.has("gclid")) {
      setSource("GoogleAds");
      clickId = urlParams.get("gclid");
    } else if (urlParams.has("ttclid")) {
      setSource("TikTok");
      clickId = urlParams.get("ttclid");
    } else if (urlParams.has("sccid")) {
      setSource("Snapchat");
      clickId = urlParams.get("sccid");
    } else if (urlParams.has("fbclid")) {
      setSource("Facebook");
      clickId = urlParams.get("fbclid");
    } else if (urlParams.has("twclid")) {
      setSource("X");
      clickId = urlParams.get("twclid");
    } else if (urlParams.has("utm_source")) {
      // 2. Check UTM parameters
      const utmSource = urlParams.get("utm_source").toLowerCase();
      const sourceMap = {
        google: "GoogleAds",
        facebook: "Facebook",
        fb: "Facebook",
        instagram: "Instagram",
        tiktok: "TikTok",
        snapchat: "Snapchat",
        twitter: "X",
        x: "X",
        linkedin: "LinkedIn",
      };
      setSource(sourceMap[utmSource] || utmSource);
    } else {
      // 3. Check stored referrer or current referrer
      const referrer = localStorage.getItem("originalReferrer") || document.referrer.toLowerCase();
      if (referrer) {
        if (referrer.includes("google.com") || referrer.includes("googleadservices.com")) {
          setSource("GoogleAds");
        } else if (referrer.includes("facebook.com") || referrer.includes("fb.com")) {
          setSource("Facebook");
        } else if (referrer.includes("instagram.com")) {
          setSource("Instagram");
        } else if (referrer.includes("tiktok.com")) {
          setSource("TikTok");
        } else if (referrer.includes("snapchat.com")) {
          setSource("Snapchat");
        } else if (referrer.includes("twitter.com") || referrer.includes("x.com")) {
          setSource("X");
        } else if (referrer.includes("linkedin.com")) {
          setSource("LinkedIn");
        } else {
          setSource("Organic");
        }
      } else {
        // 4. Check user agent for in-app browsers
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.includes("instagram")) {
          setSource("Instagram");
        } else if (userAgent.includes("tiktok")) {
          setSource("TikTok");
        } else if (userAgent.includes("snapchat")) {
          setSource("Snapchat");
        } else if (userAgent.includes("twitter") || userAgent.includes("x.com")) {
          setSource("X");
        } else {
          setSource("Direct");
        }
      }
    }

    // Only default to "Website" if no other source is identified
    if (!source) {
      setSource("Website");
    } else {
      // Store leadSource in localStorage
      localStorage.setItem("Source", source);
      localStorage.setItem("SourceTimestamp", Date.now().toString());
    }

    // console.log({
    //   urlParams: window.location.search,
    //   referrer: document.referrer,
    //   originalReferrer: localStorage.getItem("originalReferrer"),
    //   userAgent: navigator.userAgent,
    //   leadSource,
    //   clickId,
    // });
  }, []);

  const routes = [
    // HOME 
    {
      path: "/",
      element: <Home />,
      pageName: "Home",
      title: "DoDeal Properties",
      description: "DoDeal Properties",
    },
    // PRIVACY POLICY 
    {
      path: "/privacypolicy",
      element: <PrivacyPolicy />,
      pageName: "Privacy Policy",
      title: "DoDeal Properties",
      description: "DoDeal Properties",
      language: "en"
    },
    // BLOCKED IP 
    {
      path: "/blocked",
      element: <Blocked language={"en"} />,
      pageName: "Blocked",
      title: "DoDeal Properties | Blocked",
      description: "DoDeal Properties",
    },
    // THANK YOU 
    {
      path: "/thankyou",
      element: <Thankyou language={"en"} />,
      pageName: "Thank you",
      title: "DoDeal Properties",
      description: "DoDeal Properties",
      language: "en"
    },
    {
      path: "/thankyou/ar",
      element: <Thankyou language={"ar"} />,
      pageName: "Thank you",
      title: "DoDeal Properties",
      description: "DoDeal Properties",
      language: "ar"
    },
    {
      path: "/thankyou/fa",
      element: <Thankyou language={"fa"} />,
      pageName: "Thank you",
      title: "DoDeal Properties",
      description: "DoDeal Properties",
      language: "fa"
    },
    // EVENT THANK YOU
    {
      path: "/event/thankyou",
      element: <EventThankYou language={"en"} />,
      pageName: "Thank you",
      title: "DoDeal Properties",
      description: "DoDeal Properties",
      language: "en"
    },
    {
      path: "/event/thankyou/ar",
      element: <EventThankYou language={"ar"} />,
      pageName: "Thank you",
      title: "DoDeal Properties",
      description: "DoDeal Properties",
      language: "ar"
    },
    // PROJECTS 
    // TEST - EN
    {
      path: "/projects/test",
      element: <TestPage language={"en"} />,
      pageName: "DoDeal Dev",
      title: "DoDeal Dev",
      description: "DoDeal Properties | DoDeal Dev",
      language: "en"
    },
    // TEST - AR
    {
      path: "/projects/test/ar",
      element: <TestPage language={"ar"} />,
      pageName: "DoDeal Dev",
      title: "DoDeal Dev",
      description: "DoDeal Properties | DoDeal Dev",
      language: "ar"
    },

    // C1HP - HIKAL - PROJECTS
    // AZIZI - VENICE - EN 
    {
      // path: "/c1hp/azizi/venice",
      path: "/projects/azizi/venice",
      element: <AziziVeniceHikal language={"en"} />,
      pageName: "Azizi Venice",
      title: "Luxury Apartments in Dubai – Find Your Dream Home!",
      description: "Your luxurious home in Dubai is waiting to fulfill all your dreams – Find your apartment today with only 65800 AED  down  payment",
      language: "en",
      bodyBackgroundClass: "black-bg"
    },
    // AZIZI - VENICE - AR
    {
      // path: "/c1hp/azizi/venice/ar",
      path: "/projects/azizi/venice/ar",
      element: <AziziVeniceHikal language={"ar"} />,
      pageName: "Azizi Venice",
      title: "فرصة لا تعوض! شقق فاخرة في أفضل مواقع دبي للبيع.",
      description: "وحدات سكنيه ،  تجربة فاخرة بانتظارك. لا تفوت الفرصة، احجز الآن لتعيش في قلب الرفاهية والرقي مع مقدم يبدء من 65800 درهم ",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // AZIZI - MILAN - EN 
    {
      path: "/projects/azizi/milan",
      element: <AziziMilanHikal language={"en"} />,
      pageName: "Azizi Milan",
      title: "Dubai Meets Italy – Azizi Milan Apartments for Sale",
      description: "Live where Italy meets Dubai. Azizi Milan offers elegant studios to 3BR homes, world-class amenities & a prime location near IMG Worlds",
      language: "en",
      bodyBackgroundClass: "black-bg"
    },
    // AZIZI - MILAN - AR
    {
      path: "/projects/azizi/milan/ar",
      // element: <AziziMilanHikal language={"ar"} />,
      element: <HikalAziziMilan language={"ar"} />,
      pageName: "Azizi Milan",
      title: "دبي بطابع إيطالي – شقق Azizi Milan للبيع",
      description: "عيش في مكان يجمع بين سحر دبي وأناقة إيطاليا. Azizi Milan بتقدم شقق من ستوديو الى 3 غرف نوم، مع خدمات راقية وموقع استثنائي بجانب IMG Worlds.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // AZIZI - MILAN - FA
    {
      path: "/projects/azizi/milan/fa",
      element: <AziziMilanHikal language={"fa"} />,
      pageName: "Azizi Milan",
      title: "دبی را زندگی کنید، ایتالیا را احساس کنید – فرصت مالکیت در پروژه عزیزی میلان",
      description: "زندگی به سبک ایتالیایی در قلب دبی پروژه ميلان، تلفیقی از طراحی ظریف اروپایی و زندگی مدرن شهری – واحدهایی شیک از استودیو تا ۳ خوابه، با امکانات رفاهی بی‌نظیر و موقعیتی ممتاز در نزدیکی IMG Worlds",
      language: "fa",
      bodyBackgroundClass: "black-bg"
    },
    // AZIZI - MILAN - TR
    {
      path: "/projects/azizi/milan/tr",
      element: <AziziMilanHikal language={"tr"} />,
      pageName: "Azizi Milan",
      title: "Dubai’nin kalbinde İtalyan esintisi – Azizi Milan Daireleri şimdi satışta",
      description: "Azizi Milan’da şık stüdyolardan 3 yatak odalı dairelere kadar geniş seçenekler, dünya standartlarında ayrıcalıklar ve IMG Worlds’e yakın merkezi konum sizleri bekliyor.",
      language: "tr",
      bodyBackgroundClass: "black-bg"
    },
    // AZIZI - MILAN - IQ - OTP
    {
      path: "/projects/azizi/milan/iq",
      // element: <AziziMilanOtpHikal language={"ar"} />,
      element: <HikalAziziMilan language={"ar"} />,
      pageName: "Azizi Milan",
      title: "دبي بطابع إيطالي – شقق Azizi Milan للبيع",
      description: "عيش في مكان يجمع بين سحر دبي وأناقة إيطاليا. Azizi Milan بتقدم شقق من ستوديو الى 3 غرف نوم، مع خدمات راقية وموقع استثنائي بجانب IMG Worlds.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },

    // ONE - LAGUNA - AR - OTP
    {
      path: "/projects/one/laguna/ar",
      // element: <AziziMilanOtpHikal language={"ar"} />,
      element: <HikalOneLaguna language={"ar"} />,
      pageName: "One Laguna",
      title: "لاجونا ريزيدنس من ون ديفيلوبمنت | شقق فاخرة في مدينة العرب، دبي",
      description: "اكتشف لاجونا ريزيدنس، مشروع توأم الأبراج الرائع في مدينة العرب بدبي من شركة ون ديفيلوبمنت. استمتع بحياة منتجعية حول أكبر لاجون في الإمارات، منازل ذكية بالذكاء الاصطناعي، وأكثر من 30 مرفقًا. شقق من الاستوديو إلى 3 غرف نوم ابتداءً من 600 ألف درهم. الإكمال في الربع الرابع 2027.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },

    // TEST - OTP
    // {
    //   path: "/projects/otp",
    //   // element: <LandingPage1 language={"ar"} />,
    //   element: <HikalAziziMilan language={"ar"} />,
    //   pageName: "TEST OTP",
    //   title: "",
    //   description: "",
    //   language: "ar",
    //   bodyBackgroundClass: "black-bg"
    // },
    // BINGHATTI - CIRCLE - EN 
    {
      path: "/projects/binghatti/circle",
      element: <BinghattiCircleHikal language={"en"} />,
      pageName: "Binghatti Circle",
      title: "Live an Modern  Lifestyle in the Heart of Jumeirah Village Circle (JVC)",
      description: "Studios to 3BR apartments designed for comfort & style. Smart spaces for city life or spacious homes for families in vibrant JVC.",
      language: "en",
      bodyBackgroundClass: "black-bg"
    },
    // BINGHATTI - CIRCLE - AR
    {
      path: "/projects/binghatti/circle/ar",
      element: <BinghattiCircleHikal language={"ar"} />,
      pageName: "Binghatti Circle",
      title: " شﻋ ةﺎﯾﺣ ﺔﯾرﺻﻋ  ﻲﻓ بﻠﻗ ﺔﯾرﻗ ارﯾﻣﺟ",
      description: " شقق من الاستوديو حتى 3 غرف نوم بتصميم يجمع بين الراحة والأناقة. مساحات ذكية لحياة المدينة و منازل واسعة  تناسب العائلات في قرية جميرا النابضة بالحياة.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // BINGHATTI - ALJADDAF - EN 
    {
      path: "/projects/binghatti/aljaddaf",
      element: <BinghattiAlJaddafHikal language={"en"} />,
      pageName: "Binghatti Al Jaddaf",
      title: "Binghatti Projects in Al Jaddaf | Luxury Apartments in Dubai",
      description: "Discover premium Binghatti projects in Al Jaddaf, Dubai. Explore modern apartments with iconic designs, world-class amenities, and prime location near the Dubai Creek.",
      language: "en",
      bodyBackgroundClass: "black-bg"
    },
    // BINGHATTI - ALJADDAF - AR
    {
      path: "/projects/binghatti/aljaddaf/ar",
      element: <BinghattiAlJaddafHikal language={"ar"} />,
      pageName: "Binghatti Al Jaddaf",
      title: "مشاريع بن غاطي في الجداف | شقق فاخرة في دبي",
      description: "اكتشف مشاريع بن غاطي المميزة في منطقة الجداف بدبي. شقق عصرية بتصاميم أيقونية ومرافق عالمية وموقع استراتيجي بالقرب من خور دبي.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // BINGHATTI - ALJADDAF - FA (FARSI)
    {
      path: "/projects/binghatti/aljaddaf/fa",
      element: <BinghattiAlJaddafHikal language={"fa"} />,
      pageName: "Binghatti Al Jaddaf",
      title: "پروژه های بن غاطی در منطقه الجداف | آپارتمان های لوکس در دبی",
      description: "با پروژه‌های خاص و لوکس بن غاطی در منطقه الجداف آشنا شوید.آپارتمان‌های مدرن با طراحی‌های منحصر به فرد، امکانات رفاهی در سطح جهانی و موقعیت مکانی عالی در نزدیکی الخور دبی",
      language: "fa",
      bodyBackgroundClass: "black-bg"
    },
    // BINGHATTI - SKYBLADE - EN 
    {
      path: "/projects/binghatti/skyblade",
      element: <BinghattiSkybladeHikal language={"en"} />,
      pageName: "Binghatti Skyblade",
      title: "Imagine living directly in front of the Burj Khalifa, on the last plot in Downtown.",
      description: "Book your home in the heart of Downtown Dubai for just AED 50,000. A minute’s walk from Burj Khalifa and Dubai Mall – your opportunity before launch. Register now!",
      language: "en",
      bodyBackgroundClass: "black-bg"
    },
    // BINGHATTI - SKYBLADE - AR
    {
      path: "/projects/binghatti/skyblade/ar",
      element: <BinghattiSkybladeHikal language={"ar"} />,
      pageName: "Binghatti Skyblade",
      title: "تخيل أن تسكن أمام برج خليفة مباشرة، في آخر قطعة أرض بالداون تاون.",
      description: "احجز منزلك  في قلب داون تاون دبي بــــ 50,000 درهم فقط. دقيقه مشي من برج خليفة ودبي مول ، فرصتك قبل الطرح  سجّل الآن.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // DAMAC - TOWNHOUSE - EN
    {
      path: "/projects/damac/townhouse",
      element: <DamacTownhouseHikal language={"en"} />,
      pageName: "Damac Townhouse",
      title: "Own Your Luxury Home in Downtown – Exclusive 4–7 BHK Villas & Townhouses by DAMAC.",
      description: "Luxury 4–7 BHK villas & townhouses in DAMAC Downtown. Elegant design, flexible plans & a prime Dubai location.",
      language: "en",
      bodyBackgroundClass: "black-bg"
    },
    // DAMAC - TOWNHOUSE - EN
    {
      path: "/projects/damac/townhouse/ar",
      element: <DamacTownhouseHikal language={"ar"} />,
      pageName: "Damac Townhouse",
      title: "امتلك بيتك الفاخر في الداون تاون – فلل وتاون هاوس من داماك بـ 4 لـ 7 غرف نوم.",
      description: "فلل وتاون هاوس فاخرة من داماك 4 إلى 7 غرف نوم في الداون تاون، بتصميمات عصرية ، خطط سداد مرنة، وموقع مميز في قلب دبي.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },

    // NINA URL 
    {
      path: "/offers/azizi/milan/ar",
      element: <NinaAziziMilan language={"ar"} />,
      pageName: "Azizi Milan",
      title: "دبي بطابع إيطالي – شقق Azizi Milan للبيع",
      description: "عيش في مكان يجمع بين سحر دبي وأناقة إيطاليا. Azizi Milan بتقدم شقق من ستوديو الى 3 غرف نوم، مع خدمات راقية وموقع استثنائي بجانب IMG Worlds.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // VENICE
    {
      path: "/offers/azizi/venice/ar",
      element: <NinaAziziVenice language={"ar"} />,
      // element: <AsmAziziVenice language={"ar"} />,
      pageName: "Azizi Venice",
      title: "فرصة لا تعوض! شقق فاخرة في أفضل مواقع دبي للبيع.",
      description: "وحدات سكنيه ،  تجربة فاخرة بانتظارك. لا تفوت الفرصة، احجز الآن لتعيش في قلب الرفاهية والرقي مع مقدم يبدء من 65800 درهم ",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // RIVIERA 
    {
      path: "/offers/azizi/riviera/ar",
      // element: <AziziRivieraAsm language={"ar"} />,
      element: <NinaAziziRiviera language={"ar"} />,
      pageName: "Azizi Riviera",
      title: "اكتشف أسلوب الحياة في ريفييرا، قلب دبي النابض",
      description: "عِش الفخامة مع ريفييرا في دبي – فلل أنيقة، شقق عصرية، وأبراج سكنية أيقونية صُممت لتجمع بين الأناقة، الراحة، ونمط الحياة الحيوي.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // SNAPCHAT 
    {
      path: "/offers/azizi/riviera/sc/ar",
      // element: <AziziRivieraAsm language={"ar"} />,
      element: <NinaAziziRiviera language={"ar"} snapchat={true} />,
      pageName: "Azizi Riviera",
      title: "اكتشف أسلوب الحياة في ريفييرا، قلب دبي النابض",
      description: "عِش الفخامة مع ريفييرا في دبي – فلل أنيقة، شقق عصرية، وأبراج سكنية أيقونية صُممت لتجمع بين الأناقة، الراحة، ونمط الحياة الحيوي.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // ONE - LAGUNA - AR - OTP
    {
      path: "/offers/one/laguna/ar",
      // element: <AziziMilanOtpHikal language={"ar"} />,
      element: <NinaOneLaguna language={"ar"} />,
      pageName: "One Laguna",
      title: "لاجونا ريزيدنس من ون ديفيلوبمنت | شقق فاخرة في مدينة العرب، دبي",
      description: "اكتشف لاجونا ريزيدنس، مشروع توأم الأبراج الرائع في مدينة العرب بدبي من شركة ون ديفيلوبمنت. استمتع بحياة منتجعية حول أكبر لاجون في الإمارات، منازل ذكية بالذكاء الاصطناعي، وأكثر من 30 مرفقًا. شقق من الاستوديو إلى 3 غرف نوم ابتداءً من 600 ألف درهم. الإكمال في الربع الرابع 2027.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },

    // BINGHATTI - VINTAGE - AR 
    {
      path: "/offers/binghatti/vintage/ar",
      element: <NinaBinghattiVintage language={"ar"} source={source} />,
      pageName: "Binghatti Mercedes",
      title: "Binghatti Vintage | FindEstates Real Estate",
      // description: "Binghatti Vintage offers modern studios, 1 & 2-bedroom apartments in Majan, Dubailand with premium amenities, elegant design, and flexible payment plans.",
      description: "بن غاطي فينتاج مشروع سكني فاخر في مجان، دبي لاند، يضم شقق استوديو وغرفة وغرفتين نوم بتصميم عصري ومرافق متكاملة وخطط دفع مرنة.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    {
      path: "/offers/binghatti/vintage/sc/ar",
      element: <NinaBinghattiVintage language={"ar"} snapchat={true} />,
      pageName: "Binghatti Mercedes",
      title: "Binghatti Vintage | FindEstates Real Estate",
      // description: "Binghatti Vintage offers modern studios, 1 & 2-bedroom apartments in Majan, Dubailand with premium amenities, elegant design, and flexible payment plans.",
      description: "بن غاطي فينتاج مشروع سكني فاخر في مجان، دبي لاند، يضم شقق استوديو وغرفة وغرفتين نوم بتصميم عصري ومرافق متكاملة وخطط دفع مرنة.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // BINGHATTI - MERCEDES - AR
    {
      path: "/offers/binghatti/mercedes/ar",
      element: <NinaBinghattiMercedes language={"ar"} />,
      pageName: "Binghatti Mercedes",
      title: "",
      description: "",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },

    // PEACEHOMES - SKYLINE - AR
    {
      path: "/offers/peacehomes/skyline/ar",
      element: <FePeacehomesSkyline language={"ar"} />,
      pageName: "Peace Homes Skyline",
      title: "Peace Homes Skyline | وحدات فاخرة بإطلالة مميزة وعروض حصرية",
      description: "اكتشف مشروع Peace Homes Skyline مع وحدات سكنية عصرية، إطلالات بانورامية، ومرافق فاخرة. سجل الآن للاستفادة من عروض حصرية لفترة محدودة.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // PEACEHOMES - SKYLINE - EN
    {
      path: "/offers/peacehomes/skyline",
      element: <FePeacehomesSkyline language={"en"} />,
      pageName: "Peace Homes Skyline",
      title: "Peace Homes Skyline | Luxury Apartments with Stunning Views",
      description: "Discover Peace Homes Skyline featuring modern apartments, panoramic views, and premium amenities. Register now to access exclusive limited-time offers.",
      language: "en",
      bodyBackgroundClass: "black-bg"
    },

    // C4PN - PROPERTY - OFFER
    // AZIZI - VENICE - EN 
    {
      path: "/offer/azizi/venice",
      element: <AziziVeniceNina language={"en"} />,
      pageName: "Azizi Venice",
      title: "Luxury Apartments in Dubai – Find Your Dream Home!",
      description: "Your luxurious home in Dubai is waiting to fulfill all your dreams – Find your apartment today with only 65800 AED  down  payment.",
      language: "en"
    },
    // AZIZI - VENICE - AR
    {
      path: "/offer/azizi/venice/ar",
      element: <AziziVeniceNina language={"ar"} />,
      pageName: "Azizi Venice",
      title: "فرصة لا تعوض! شقق فاخرة في أفضل مواقع دبي للبيع.",
      description: "وحدات سكنيه ،  تجربة فاخرة بانتظارك. لا تفوت الفرصة، احجز الآن لتعيش في قلب الرفاهية والرقي مع مقدم يبدء من 65800 درهم ",
      language: "ar"
    },
    // AZIZI - LEILY - EN 
    {
      path: "/offer/azizi/leily",
      element: <NinaAziziLeily language={"en"} />,
      pageName: "Azizi Leily",
      title: "Azizi Leily Dubai | High-ROI Residences in Al Jaddaf with Flexible Payment Plan",
      description: "Azizi Leily offers competitively priced apartments in Al Jaddaf with a 70/30 payment plan and handover in December 2027. Benefit from a highly strategic location near Healthcare City, Dubai Festival City, Downtown, and major highways. Premium amenities include a rooftop infinity pool, wellness spa, gym, and kids’ facilities.",
      language: "en"
    },
    // AZIZI - LEILY - AR
    {
      path: "/offer/azizi/leily/ar",
      element: <NinaAziziLeily language={"ar"} />,
      pageName: "Azizi Leily",
      title: "عزيزي ليلي دبي | شقق عالية العائد في الجداف مع خطة دفع مرنة",
      description: "يقدم مشروع عزيزي ليلي في الجداف شققاً بأسعار تنافسية مع خطة دفع 70/30 وتسليم في ديسمبر 2027. استمتع بموقع استراتيجي قريب من مدينة دبي الطبية، دبي فستيفال سيتي، وسط مدينة دبي، والطرق الرئيسية. يشمل المشروع مرافق فاخرة مثل مسبح إنفينيتي على السطح، سبا، صالة رياضية، ومناطق لعب للأطفال.",
      language: "ar"
    },
    // EVENT _ LIBYA - AR
    {
      path: "/event/libya",
      element: <NinaLibyaEvent language={"ar"} />,
      pageName: "Libya Event",
      title: "",
      description: "",
      language: "ar"
    },
    // AZIZI - VENICE - EN - S
    {
      path: "/offer/azizi/venice/en-s",
      element: <AziziVeniceSnapchatNina language={"en"} />,
      pageName: "Azizi Venice",
      title: "Luxury Apartments in Dubai – Find Your Dream Home!",
      description: "Your luxurious home in Dubai is waiting to fulfill all your dreams – Find your apartment today with only 65800 AED  down  payment.",
      language: "en"
    },
    // AZIZI - VENICE - AR - S
    {
      path: "/offer/azizi/venice/ar-s",
      element: <AziziVeniceSnapchatNina language={"ar"} />,
      pageName: "Azizi Venice",
      title: "فرصة لا تعوض! شقق فاخرة في أفضل مواقع دبي للبيع.",
      description: "وحدات سكنيه ،  تجربة فاخرة بانتظارك. لا تفوت الفرصة، احجز الآن لتعيش في قلب الرفاهية والرقي مع مقدم يبدء من 65800 درهم ",
      language: "ar"
    },
    // AZIZI - RIVIERA - RETAIL - EN
    {
      path: "/offer/azizi/riviera/retail",
      element: <AziziRivieraRetailNina language={"en"} />,
      pageName: "Azizi Riviera Retail",
      title: "Secure Your Spot at Dubai’s Central Boulevard – 10 Exclusive Commercial Units with Water Views!",
      description: "Invest in Dubai retail with 10 exclusive units offering customizable designs and 15%-20% ROI. Limited availability—secure your spot now",
      language: "en"
    },
    // AZIZI - RIVIERA - RETAIL - AR
    {
      path: "/offer/azizi/riviera/retail/ar",
      element: <AziziRivieraRetailNina language={"ar"} />,
      pageName: "Azizi Riviera Retail",
      title: "استثمر في أفضل الوحدات التجاريه بدبي -  وحدات حصرية مع رؤية مميزة وعائدات استثمارية عالية",
      description: "امتلك واحدة من 10 وحدات تجارية حصرية في دبي في مواقع مميزة. توفر هذه الوحدات رؤية رائعة للعلامات التجارية الدولية، مع عوائد استثمارية مميزة تصل إلى 20%.",
      language: "ar"
    },
    // AZIZI - RIVIERA - RETAIL - EN-S
    {
      path: "/offer/azizi/riviera/retail/en-s",
      element: <AziziRivieraRetailSnapchatNina language={"en"} />,
      pageName: "Azizi Riviera Retail",
      title: "Secure Your Spot at Dubai’s Central Boulevard – 10 Exclusive Commercial Units with Water Views!",
      description: "Invest in Dubai retail with 10 exclusive units offering customizable designs and 15%-20% ROI. Limited availability—secure your spot now",
      language: "en"
    },
    // AZIZI - RIVIERA - RETAIL - AR-S
    {
      path: "/offer/azizi/riviera/retail/ar-s",
      element: <AziziRivieraRetailSnapchatNina language={"ar"} />,
      pageName: "Azizi Riviera Retail",
      title: "استثمر في أفضل الوحدات التجاريه بدبي -  وحدات حصرية مع رؤية مميزة وعائدات استثمارية عالية",
      description: "امتلك واحدة من 10 وحدات تجارية حصرية في دبي في مواقع مميزة. توفر هذه الوحدات رؤية رائعة للعلامات التجارية الدولية، مع عوائد استثمارية مميزة تصل إلى 20%.",
      language: "ar"
    },
    // DAMAC - RIVERSIDE - EN 
    {
      path: "/offer/damac/riverside",
      element: <DamacRiversideNina language={"en"} />,
      pageName: "Damac Riverside",
      title: "Luxury Apartments in Dubai with a breathtaking 1500m-long river",
      description: "Luxury in Dubai: State-of-the-Art Fitness Center, Relaxing Spa, Children's Play Area, Thrilling Adventure Zone, and an Exclusive Gaming Zone for Unmatched Recreation.",
      language: "en"
    },
    // DAMAC - RIVERSIDE - AR
    {
      path: "/offer/damac/riverside/ar",
      element: <DamacRiversideNina language={"ar"} />,
      pageName: "Damac Riverside",
      title: "شقق فاخرة في دبي تتميز بنهر خلاب يمتد على طول 1500 متر، يوفر لك أجواء ساحرة وتجربة معيشية لا تُضاهى",
      description: "شقق فاخرة في دبي مع تجربة معيشية استثنائية نهر خلاب يمتد بطول 1500 متر، يحيط به مناظر طبيعية رائعة وأجواء هادئة تجمع بين الفخامة والجمال الطبيعي دفعه حجز 45.000 درهم ",
      language: "ar"
    },
    // DAMAC - RIVERSIDE - EN-S 
    {
      path: "/offer/damac/riverside/en-s",
      element: <DamacRiversideSnapchatNina language={"en"} />,
      pageName: "Damac Riverside",
      title: "Luxury Apartments in Dubai with a breathtaking 1500m-long river",
      description: "Luxury in Dubai: State-of-the-Art Fitness Center, Relaxing Spa, Children's Play Area, Thrilling Adventure Zone, and an Exclusive Gaming Zone for Unmatched Recreation.",
      language: "en"
    },
    // DAMAC - RIVERSIDE - EN-S 
    {
      path: "/offer/damac/riverside/ar-s",
      element: <DamacRiversideSnapchatNina language={"ar"} />,
      pageName: "Damac Riverside",
      title: "شقق فاخرة في دبي تتميز بنهر خلاب يمتد على طول 1500 متر، يوفر لك أجواء ساحرة وتجربة معيشية لا تُضاهى",
      description: "شقق فاخرة في دبي مع تجربة معيشية استثنائية نهر خلاب يمتد بطول 1500 متر، يحيط به مناظر طبيعية رائعة وأجواء هادئة تجمع بين الفخامة والجمال الطبيعي دفعه حجز 45.000 درهم ",
      language: "ar"
    },
    // AZIZI - MILAN - EN
    {
      path: "/offer/azizi/milan",
      element: <AziziMilanNina language={"en"} />,
      pageName: "Azizi Milan",
      title: "Dubai Meets Italy – Azizi Milan Apartments for Sale",
      description: "Live where Italy meets Dubai. Azizi Milan offers elegant studios to 3BR homes, world-class amenities & a prime location near IMG Worlds",
      language: "en"
    },
    // AZIZI - MILAN - AR
    {
      path: "/offer/azizi/milan/ar",
      element: <AziziMilanNina language={"ar"} />,
      pageName: "Azizi Milan",
      title: "دبي بطابع إيطالي – شقق Azizi Milan للبيع",
      description: "عيش في مكان يجمع بين سحر دبي وأناقة إيطاليا. Azizi Milan بتقدم شقق من ستوديو الى 3 غرف نوم، مع خدمات راقية وموقع استثنائي بجانب IMG Worlds.",
      language: "ar"
    },
    // AZIZI - MILAN - EN - S
    {
      path: "/offer/azizi/milan/en-s",
      element: <AziziMilanSnapchatNina language={"en"} />,
      pageName: "Azizi Milan",
      title: "Dubai Meets Italy – Azizi Milan Apartments for Sale",
      description: "Live where Italy meets Dubai. Azizi Milan offers elegant studios to 3BR homes, world-class amenities & a prime location near IMG Worlds",
      language: "en"
    },
    // AZIZI - MILAN - AR - S
    {
      path: "/offer/azizi/milan/ar-s",
      element: <AziziMilanSnapchatNina language={"ar"} />,
      pageName: "Azizi Milan",
      title: "دبي بطابع إيطالي – شقق Azizi Milan للبيع",
      description: "عيش في مكان يجمع بين سحر دبي وأناقة إيطاليا. Azizi Milan بتقدم شقق من ستوديو الى 3 غرف نوم، مع خدمات راقية وموقع استثنائي بجانب IMG Worlds.",
      language: "ar"
    },

    // C6AP - APOELEZZ
    // AZIZI - MILAN - EN
    {
      path: "/c6ap/azizi/milan",
      element: <AziziMilanApoelezz language={"en"} />,
      pageName: "Azizi Milan",
      title: "Dubai Meets Italy – Azizi Milan Apartments for Sale",
      description: "Live where Italy meets Dubai. Azizi Milan offers elegant studios to 3BR homes, world-class amenities & a prime location near IMG Worlds",
      language: "en",
      bodyBackgroundClass: "black-bg"
    },
    // AZIZI - MILAN - AR
    {
      path: "/c6ap/azizi/milan/ar",
      element: <AziziMilanApoelezz language={"ar"} />,
      pageName: "Azizi Milan",
      title: "دبي بطابع إيطالي – شقق Azizi Milan للبيع",
      description: "عيش في مكان يجمع بين سحر دبي وأناقة إيطاليا. Azizi Milan بتقدم شقق من ستوديو الى 3 غرف نوم، مع خدمات راقية وموقع استثنائي بجانب IMG Worlds.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // BINGHATTI - AQUARISE - EN
    {
      path: "/c6ap/binghatti/aquarise",
      element: <BinghattiAquariseApoelezz language={"en"} />,
      pageName: "Binghatti Aquarise",
      title: "Business Bay Apartments – Skyline & Waterfront Views",
      description: "Experience striking architecture and luxury living in Business Bay. Studios to 4BR apartments with pools & skyline views. Waterfront lifestyle awaits.",
      language: "en",
      bodyBackgroundClass: "black-bg"
    },
    // BINGHATTI - AQUARISE - AR
    {
      path: "/c6ap/binghatti/aquarise/ar",
      element: <BinghattiAquariseApoelezz language={"ar"} />,
      pageName: "Binghatti Aquarise",
      title: "شقق الخليج التجاري - إطلالات على الأفق والواجهة البحرية",
      description: "اختبر روعة التصميم المعماري الفريد والحياة الفاخرة في الخليج التجاري. شقق من استوديو إلى 4 غرف نوم مع مسابح وإطلالات بانورامية. أسلوب حياة راقٍ على الواجهة المائية بانتظارك",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // BINGHATTI - HILLVIEWS - EN
    {
      path: "/c6ap/binghatti/hillviews",
      element: <BinghattiHillviewsApoelezz language={"en"} />,
      pageName: "Binghatti Hillviews",
      title: "Experience Elevated Living in Dubai’s Most Exciting New Residential Launch",
      description: "Discover a new level of luxury with spacious studios, 1 & 2 bedroom apartments in a prime Dubai location. World-class amenities, skyline views, and unbeatable lifestyle. Register now for early access.",
      language: "en",
      bodyBackgroundClass: "black-bg"
    },
    // BINGHATTI - HILLVIEWS - AR
    {
      path: "/c6ap/binghatti/hillviews/ar",
      element: <BinghattiHillviewsApoelezz language={"ar"} />,
      pageName: "Binghatti Hillviews",
      title: "عِش تجربة مميزة في أحدث مشروع سكني في دبي",
      description: "اكتشف مستوىً جديدًا من الرفاهية مع استوديوهات واسعة، وشقق بغرفة نوم واحدة أو غرفتين في موقعٍ مميزٍ بدبي. مرافق عالمية، إطلالات خلابة ، وأسلوب حياة لا يُضاهى. سجّل الآن للحصول على أولوية الحجز.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // TIGER - ANANDA - EN
    {
      path: "/c6ap/tiger/ananda",
      element: <TigerAnandaApoelezz language={"en"} />,
      pageName: "Tiger Ananda",
      title: "Ananda Residences | Luxury Apartments in Motor City, Dubai",
      description: "Discover a masterpiece of modern luxury in the heart of Motor City. These twin towers offer elegantly designed apartments with breathtaking views, world-class amenities, and a flexible payment plan. Experience sophisticated living or seize a prime investment opportunity in Dubai.",
      language: "en",
      bodyBackgroundClass: "black-bg"
    },
    // TIGER - ANANDA - AR
    {
      path: "/c6ap/tiger/ananda/ar",
      element: <TigerAnandaApoelezz language={"ar"} />,
      pageName: "Tiger Ananda",
      title: "الأناندا ريزيدنس | شقق فاخرة في موتور سيتي، دبي",
      description: "اكتشف تحفة من الفخامة العصرية في قلب موتور سيتي. تقدم هذه الأبراج التوأم شققًا مصممة بأناقة مع إطلالات خلابة، ومرافق عالمية المستوى، وخطة دفع مرنة. تمتع بتجربة معيشية راقية أو اغتنم فرصة استثمارية مميزة في دبي.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },

    // C8AS - ASM 
    // AZIZI - VENICE - EN 
    {
      path: "/c8as/azizi/venice",
      element: <AziziVeniceAsm language={"en"} />,
      pageName: "Azizi Venice",
      title: "Luxury Apartments in Dubai – Find Your Dream Home!",
      description: "Your luxurious home in Dubai is waiting to fulfill all your dreams – Find your apartment today with only 65800 AED  down  payment",
      language: "en",
      bodyBackgroundClass: "black-bg"
    },
    // AZIZI - VENICE - AR
    {
      path: "/asm/azizi/venice/ar",
      element: <AziziVeniceAsm language={"ar"} />,
      // element: <AsmAziziVenice language={"ar"} />,
      pageName: "Azizi Venice",
      title: "فرصة لا تعوض! شقق فاخرة في أفضل مواقع دبي للبيع.",
      description: "وحدات سكنيه ،  تجربة فاخرة بانتظارك. لا تفوت الفرصة، احجز الآن لتعيش في قلب الرفاهية والرقي مع مقدم يبدء من 65800 درهم ",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // AZIZI - MILAN - EN 
    {
      path: "/c8as/azizi/milan",
      element: <AziziMilanAsm language={"en"} />,
      pageName: "Azizi Milan",
      title: "Dubai Meets Italy – Azizi Milan Apartments for Sale",
      description: "Live where Italy meets Dubai. Azizi Milan offers elegant studios to 3BR homes, world-class amenities & a prime location near IMG Worlds",
      language: "en",
      bodyBackgroundClass: "black-bg"
    },
    // AZIZI - MILAN - AR
    {
      path: "/asm/azizi/milan/ar",
      // element: <AziziMilanAsm language={"ar"} />,
      element: <AsmAziziMilan language={"ar"} />,
      pageName: "Azizi Milan",
      title: "دبي بطابع إيطالي – شقق Azizi Milan للبيع",
      description: "عيش في مكان يجمع بين سحر دبي وأناقة إيطاليا. Azizi Milan بتقدم شقق من ستوديو الى 3 غرف نوم، مع خدمات راقية وموقع استثنائي بجانب IMG Worlds.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // AZIZI - RIVIERA - EN 
    {
      path: "/c8as/azizi/riviera",
      element: <AziziRivieraAsm language={"en"} />,
      pageName: "Azizi Riviera",
      title: "Discover Riviera Living in the Heart of Dubai",
      description: "Experience luxury living with Riviera in Dubai—stylish villas, modern apartments, and iconic towers crafted for elegance, comfort, and vibrant city life.",
      language: "en",
      bodyBackgroundClass: "black-bg"
    },
    // AZIZI - RIVIERA - AR
    {
      path: "/asm/azizi/riviera/ar",
      element: <AziziRivieraAsm language={"ar"} />,
      // element: <AsmAziziRiviera language={"ar"} />,
      pageName: "Azizi Riviera",
      title: "اكتشف أسلوب الحياة في ريفييرا، قلب دبي النابض",
      description: "عِش الفخامة مع ريفييرا في دبي – فلل أنيقة، شقق عصرية، وأبراج سكنية أيقونية صُممت لتجمع بين الأناقة، الراحة، ونمط الحياة الحيوي.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // RICHMIND
    // OYSTRA
    {
      path: "/richmind/oystra",
      element: <RichMindOystra language={"en"} />,
      pageName: "RichMind Oystra",
      title: "Oystra Al Marjan Island | Zaha Hadid-Designed Residences by Richmind Development",
      description: "Discover Oystra on Al Marjan Island — a landmark waterfront residence in Ras Al Khaimah by Richmind Development, designed by Zaha Hadid Architects. Featuring fluid architectural forms, over 75 % of homes with sea views, resort-style amenities and the island’s first 360° infinity pool. Completion expected 2029.",
      language: "en",
      bodyBackgroundClass: "black-bg"
    },
    {
      path: "/richmind/oystra/ar",
      element: <RichMindOystra language={"ar"} />,
      pageName: "RichMind Oystra",
      title: "Oystra Al Marjan Island | Zaha Hadid-Designed Residences by Richmind Development",
      description: "Discover Oystra on Al Marjan Island — a landmark waterfront residence in Ras Al Khaimah by Richmind Development, designed by Zaha Hadid Architects. Featuring fluid architectural forms, over 75 % of homes with sea views, resort-style amenities and the island’s first 360° infinity pool. Completion expected 2029.",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },
    // TAVIRA
    // AZIZI - VENICE
    {
      path: "/c327tv/azizi/venice/ar",
      element: <TaviraAziziVenice language={"ar"} />,
      pageName: "Azizi Venice",
      title: "فرصة لا تعوض! شقق فاخرة في أفضل مواقع دبي للبيع.",
      description: "وحدات سكنيه ،  تجربة فاخرة بانتظارك. لا تفوت الفرصة، احجز الآن لتعيش في قلب الرفاهية والرقي مع مقدم يبدء من 65800 درهم ",
      language: "ar",
      bodyBackgroundClass: "black-bg"
    },

    // NEW
    // HIKALRE.DODEALCRM.COM
    {
      path: "/azizi/venice/retail/ar",
      element: <AziziVeniceRetail language={"ar"} />,
      language: "ar",
      bodyBackgroundClass: "black-bg",
      pageName: "Azizi Venice",
      title: "",
      description: "",
    },
    {
      path: "/azizi/venice/retail",
      element: <AziziVeniceRetail language={"en"} />,
      language: "en",
      bodyBackgroundClass: "black-bg",
      pageName: "Azizi Venice",
      title: "",
      description: "",
    },
    {
      path: "/azizi/venice/ar",
      element: <AziziVeniceApartment language={"ar"} />,
      language: "ar",
      bodyBackgroundClass: "black-bg",
      pageName: "Azizi Venice",
      title: "",
      description: "",
    },
    {
      path: "/azizi/venice",
      element: <AziziVeniceApartment language={"en"} />,
      language: "en",
      bodyBackgroundClass: "black-bg",
      pageName: "Azizi Venice",
      title: "",
      description: "",
    },
    {
      path: "/azizi/florence",
      element: <AziziFlorence language={"en"} />,
      language: "en",
      bodyBackgroundClass: "black-bg",
      pageName: "Azizi Florence",
      title: "",
      description: "",
    },
    {
      path: "/azizi/florence/ar",
      element: <AziziFlorence language={"ar"} />,
      language: "ar",
      bodyBackgroundClass: "black-bg",
      pageName: "Azizi Florence",
      title: "",
      description: "",
    },
    {
      path: "/binghatti/spectre",
      element: <BinghattiSpectre language={"en"} />,
      language: "en",
      bodyBackgroundClass: "black-bg",
      pageName: "Binghatti Spectre",
      title: "",
      description: "",
    },
    {
      path: "/binghatti/spectre/ar",
      element: <BinghattiSpectre language={"ar"} />,
      language: "ar",
      bodyBackgroundClass: "black-bg",
      pageName: "Binghatti Spectre",
      title: "",
      description: "",
    },
    // END OF HIKALRE.DODEALCRM.COM
    // SIP AI TEST
    {
      path: "/sip-ai-test",
      element: <SipAiTest language={"en"} />,
      pageName: "SIP AI TEST",
      title: "DoDeal SIP AI Test",
      description: "DoDeal Properties",
    },
    // NOT FOUND 
    {
      path: "/*",
      element: <TestPage language={"en"} />,
      pageName: "Page Not Found",
      title: "DoDeal Properties Not Found",
      description: "DoDeal Properties",
    },
  ];

  return (
    <HelmetProvider>
      <HelmetManager routes={routes} />
      {/* PIXEL */}
      {/* Google Tag Manager (noscript) - HIKAL - 250110 */}
      {/* <noscript
      ><iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-WM52CQMZ"
        height="0"
        width="0"
        style="display: none; visibility: hidden"
      ></iframe></noscript> */}
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-T37TXKS4"
        height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
      {/* End Google Tag Manager (noscript) */}

      {/* ROUTES */}
      <Routes>
        <Route path="/" element={<Home />} />
        {routes.map((route, index) => {
          return (
            <Route
              key={index}
              path={route.path}
              element={
                <LanguageWrapper language={route.language}>
                  {route.element}
                </LanguageWrapper>
              }
            />
          );
        })}
      </Routes>
    </HelmetProvider>
  );
}

export default App;
